import api from '../client'

// Requests stay in the organization the page asked for, even if the selected
// organization changes while one is in flight (same rule as prepacksApi).
const scopedConfig = (config = {}, overrides = {}) => ({
  ...config,
  ...overrides,
  _skipOrgRewrite: true,
})

// Affiliate links: player share links and the marketing links operators make
// for named affiliates, tracked on the same share ledger.
export const affiliateLinksApi = {
  getSummary: async (orgSlug, params = {}, config = {}) => {
    const response = await api.get(`/${orgSlug}/affiliate-links/summary`, scopedConfig(config, { params }))
    return response.data
  },
  listLinks: async (orgSlug, params = {}, config = {}) => {
    const response = await api.get(`/${orgSlug}/affiliate-links/links`, scopedConfig(config, { params }))
    return response.data
  },
  listSharers: async (orgSlug, params = {}, config = {}) => {
    const response = await api.get(`/${orgSlug}/affiliate-links/sharers`, scopedConfig(config, { params }))
    return response.data
  },
  // The funnel by UTC day, or by UTC hour with granularity "hour" (ranges of
  // seven days or less); every bucket of the range is present.
  getSeries: async (orgSlug, params = {}, config = {}) => {
    const response = await api.get(`/${orgSlug}/affiliate-links/series`, scopedConfig(config, { params }))
    return response.data
  },
  // Each affiliate's marketing links and their funnel in the period; active
  // affiliates are listed even without activity.
  listAffiliateStats: async (orgSlug, params = {}, config = {}) => {
    const response = await api.get(`/${orgSlug}/affiliate-links/affiliate-stats`, scopedConfig(config, { params }))
    return response.data
  },
  // Credited bets as CSV; the period filters on when each bet was placed.
  downloadCreditedBets: async (orgSlug, params = {}, config = {}) => {
    const response = await api.get(
      `/${orgSlug}/affiliate-links/credited-bets/export`,
      scopedConfig(config, { params, responseType: 'blob' }),
    )
    return response.data
  },
  downloadLinks: async (orgSlug, params = {}, config = {}) => {
    const response = await api.get(
      `/${orgSlug}/affiliate-links/links/export`,
      scopedConfig(config, { params, responseType: 'blob' }),
    )
    return response.data
  },
  downloadSharers: async (orgSlug, params = {}, config = {}) => {
    const response = await api.get(
      `/${orgSlug}/affiliate-links/sharers/export`,
      scopedConfig(config, { params, responseType: 'blob' }),
    )
    return response.data
  },
  getSettings: async (orgSlug, config = {}) => {
    const response = await api.get(`/${orgSlug}/affiliate-links/settings`, scopedConfig(config))
    return response.data
  },
  updateSettings: async (orgSlug, body, config = {}) => {
    const response = await api.put(`/${orgSlug}/affiliate-links/settings`, body, scopedConfig(config))
    return response.data
  },
  // Ends a link now (marketing or player); returns the updated link row.
  endLink: async (orgSlug, id, config = {}) => {
    const response = await api.post(`/${orgSlug}/affiliate-links/links/${encodeURIComponent(id)}/end`, {}, scopedConfig(config))
    return response.data
  },
  // Creates a marketing link for an affiliate: { id, code, url, created_at, expires_at }.
  createLink: async (orgSlug, body, config = {}) => {
    const response = await api.post(`/${orgSlug}/affiliate-links/links`, body, scopedConfig(config))
    return response.data
  },
  listAffiliates: async (orgSlug, config = {}) => {
    const response = await api.get(`/${orgSlug}/affiliate-links/affiliates`, scopedConfig(config))
    return response.data
  },
  createAffiliate: async (orgSlug, body, config = {}) => {
    const response = await api.post(`/${orgSlug}/affiliate-links/affiliates`, body, scopedConfig(config))
    return response.data
  },
  updateAffiliate: async (orgSlug, id, body, config = {}) => {
    const response = await api.patch(`/${orgSlug}/affiliate-links/affiliates/${encodeURIComponent(id)}`, body, scopedConfig(config))
    return response.data
  },
}
